import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import WorkOrderCreateForm from './WorkOrderCreateForm';
import WorkOrderEditForm from './WorkOrderEditForm';

const Form: React.FC = () => {
  const location = useLocation();
  const isEdit = matchPath({ path: '/pms/pms-work-orders/:id/edit', end: true }, location.pathname) != null;

  if (isEdit) {
    return <WorkOrderEditForm />;
  }

  return <WorkOrderCreateForm />;
};

export default Form;
